import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    dismissAfter: { type: Number, default: 5000 },
    browserNotify: { type: Boolean, default: false },
    browserTitle: { type: String, default: "" },
    browserBody: { type: String, default: "" }
  }

  connect() {
    this.element.classList.add("transition-opacity", "duration-300")
    this.timeout = setTimeout(() => this.dismiss(), this.dismissAfterValue)
    this.maybeSendBrowserNotification()
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.classList.add("opacity-0")
    setTimeout(() => this.element.remove(), 300)
  }

  maybeSendBrowserNotification() {
    if (!this.browserNotifyValue) return
    if (!("Notification" in window)) return
    if (Notification.permission !== "granted") return

    const title = this.browserTitleValue
    const options = { body: this.browserBodyValue }

    if (navigator.serviceWorker && navigator.serviceWorker.controller) {
      navigator.serviceWorker.ready.then(reg => reg.showNotification(title, options))
    } else {
      new Notification(title, options)
    }
  }
}
